export const AWS_ACCOUNT_ID = '982619301361';
export const AWS_PROFILE = 'matthis';
export const AWS_REGION = 'eu-west-3';
export const DEPLOY_BUCKET = 'belles-demeures-deploy-devs-20251105141148450900000002';
export const ENV_NAME = 'devs';
export const IS_RUNNING_LOCALLY = false;
export const LOCALHOST = '';
export const SCRAPER_BUCKET_NAME = 'belles-demeures-scraper-devs-20251105141148451000000003';
export const SCRAPER_FUNCTION_NAME = 'belles-demeures-scraper-devs';
export const SCRAPER_URL = 'http://:9533';
export const WEBSITE_BACKEND_FUNCTION_NAME = 'belles-demeures-website_backend-devs';
export const WEBSITE_BACKEND_URL = 'https://house.matthis.link';
export const WEBSITE_FRONTEND_URL = 'https://matthis.link';

// ------------------------------------------------------------
// Terraform output for devs
// ------------------------------------------------------------
// export const AWS_ACCOUNT_ID = "982619301361";
// export const AWS_PROFILE = "matthis";
// export const AWS_REGION = "eu-west-3";
// export const DEPLOY_BUCKET = "belles-demeures-deploy-devs-20251105141148450900000002";
// export const SCRAPER_BUCKET_NAME = "belles-demeures-scraper-devs-20251105141148451000000003";
// export const SCRAPER_FUNCTION_NAME = "belles-demeures-scraper-devs";
// export const WEBSITE_BACKEND_FUNCTION_NAME = "belles-demeures-website_backend-devs";
// export const WEBSITE_BACKEND_URL = "https://house.matthis.link";
// export const WEBSITE_FRONTEND_URL = "https://matthis.link";
// ------------------------------------------------------------
